import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    Button,
    Input,
    Label,
    Table,
    Spinner,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const RouterConfig = () => {
    const [machines, setMachines] = useState([]);
    const [routers, setRouters] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        company: "",
        serial_no: "",
        sim_card_number: "",
        ip_address: "",
        config_ip: "",
        vpn_ip: "",
        vpn_name: "",
        iot_username: "",
        iot_password: "",
        parameter_username: "",
        parameter_password: "",
        vpn_file: null,
        configuration_file: null,
        machine: "",
        image: "router_images\router906.jpeg",

    });
  const [companyData, setCompanyData] = useState([]);
    const token = localStorage.getItem("access");
 const fetchCompany = async () => {
    try {
      const response = await fetch("https://api.hanoch.in/api/company", {
      });

      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setCompanyData(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    
  };

  useEffect(() => {
    fetchCompany();
  }, []);

    // Fetch Routers
    const fetchRouters = async () => {
        try {
            setLoading(true);
            const res = await axios.get(
                "https://api.hanoch.in/api/router-systems/",

            );
            console.log("routers", res)
            setRouters(res?.results);

        } catch (error) {
            console.error("Error fetching routers", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRouters();
    }, []);

    // Handle Input Change
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    // Submit Form

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const data = new FormData();

            Object.keys(formData).forEach((key) => {
                data.append(key, formData[key]);
            });

            await axios.post(
                "https://api.hanoch.in/api/router-systems/",
                data,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  }
            );

            fetchRouters();

        } catch (error) {
            console.error("Submit error", error);
        }
    };


    const fetchMachine = async () => {
        try {
            const response = await fetch("https://api.hanoch.in/api/machines", {
            });

            if (response.ok) {
                const data = await response.json();
                setMachines(data?.data);
            } else if (response.status === 401) {

                localStorage.removeItem("authUser");
                localStorage.removeItem("admin");
            } else {
                console.error("Error fetching data:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    useEffect(() => {
        fetchMachine();
    }, []);
    document.title = "Router Configuration | OptiMize";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="OptiMize" breadcrumbItem="Router Configuration" />
                    {/* Router Form */}
                    <Card>
                        <CardHeader>
                            <h5>Router Configuration</h5>
                        </CardHeader>
                        <CardBody>
                            <form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={4}>
                                        <Label>Name</Label>
                                        <Input name="name" value={formData.name} onChange={handleChange} />
                                    </Col>
                                    <Col md={4}>
                                        <Label>Company</Label>
                                         <select
                id="company"
                className="form-control"
                placeholder="Company Name"
                name="company"
                value={formData.company}
                onChange={handleChange}
                required
              >
                <option key="default">Select Company</option>
                {companyData.map((company, index) => (
                  <>
                    <option key={index} value={company.id}>
                      {company.name}
                    </option>
                  </>
                ))}
              </select>
                                    </Col>
                                    {/* <Col md={4}>
                    <Label>Machine ID</Label>
                    <Input name="machine" value={formData.machine} onChange={handleChange}/>
                  </Col> */}
                                    <Col md={4}>
                                        <Label>Select Machine</Label>
                                        <select
                                            className="form-control"
                                            id="machine"
                                            name="machine"
                                            value={formData?.machine}
                                            onChange={handleChange}
                                        >
                                            <option key="default" value="">
                                                Select Machine
                                            </option>
                                            <>
                                                {machines?.map((machine, index) => (
                                                    <option key={index} value={machine?.id}>
                                                        {machine?.name}
                                                    </option>
                                                ))}
                                            </>
                                        </select>
                                    </Col>
                                    <Col md={4}>
                                        <Label>Serial No</Label>
                                        <Input name="serial_no" value={formData.serial_no} onChange={handleChange} />
                                    </Col>
                                    <Col md={4}>
                                        <Label>Sim card number</Label>
                                        <Input name="sim_card_number" value={formData.sim_card_number} onChange={handleChange} />
                                    </Col>
                                    <Col md={4}>
                                        <Label>IP Address</Label>
                                        <Input name="ip_address" value={formData.ip_address} onChange={handleChange} />
                                    </Col>
                                    <Col md={4}>
                                        <Label>Config IP</Label>
                                        <Input name="config_ip" value={formData.config_ip} onChange={handleChange} />
                                    </Col>
                                    <Col md={4}>
                                        <Label>Configuration File</Label>
                                        <Input
                                            type="file"
                                            name="configuration_file"
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    configuration_file: e.target.files[0],
                                                })
                                            }
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <Label>VPN IP</Label>
                                        <Input name="vpn_ip" value={formData.vpn_ip} onChange={handleChange} />
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md={4}>
                                        <Label>Vpn file</Label>
                                        <Input name="vpn_file" type="file" onChange={(e) => setFormData({ ...formData, vpn_file: e.target.files[0] })} />
                                    </Col>
                                    <Col md={4}>
                                        <Label>VPN Name</Label>
                                        <Input name="vpn_name" value={formData.vpn_name} onChange={handleChange} />
                                    </Col>
                                    <Col md={4}>
                                        <Label>IOT Username</Label>
                                        <Input name="iot_username" value={formData.iot_username} onChange={handleChange} />
                                    </Col>

                                </Row>

                                <Row className="mt-3">
                                    <Col md={4}>
                                        <Label>IOT Password</Label>
                                        <Input type="password" name="iot_password" value={formData.iot_password} onChange={handleChange} />
                                    </Col>
                                    <Col md={4}>
                                        <Label>Parameter Username</Label>
                                        <Input name="parameter_username" value={formData.parameter_username} onChange={handleChange} />
                                    </Col>

                                    <Col md={4}>
                                        <Label>Parameter Password</Label>
                                        <Input type="password" name="parameter_password" value={formData.parameter_password} onChange={handleChange} />
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                </Row>
                                <Button color="primary" className="mt-4">
                                    Save Router
                                </Button>
                            </form>

                        </CardBody>
                    </Card>

                    {/* Router List */}

                    <Card className="mt-4">
                        <CardHeader>
                            <h5>Configured Routers</h5>
                        </CardHeader>

                        <CardBody>

                            {loading ? (
                                <Spinner />
                            ) : (

                                <Row>
                                    {routers?.map((router, index) => {

                                        const machine = machines?.find(
                                            (m) => m.id === router.machine
                                        );

                                        return (
                                            <Col xl={4} md={6} key={index}>
                                                <Card className="shadow-sm">
                                                    <CardHeader className="d-flex justify-content-between">
                                                        <strong>{router.name}</strong>
                                                        <span className="text-muted">{router.serial_no}</span>
                                                    </CardHeader>

                                                    <CardBody>

                                                        <div className="text-center mb-3">
                                                            {router.image && (
                                                                <img
                                                                    src={`https://api.hanoch.in/media/${router.image}`}
                                                                    alt="router"
                                                                    height="70"
                                                                    className="img-fluid"
                                                                />
                                                            )}
                                                        </div>

                                                        <p><b>Company:</b> {router.company_name}</p>

                                                        <p>
                                                            <b>Machine:</b> {machine?.name || "-"}
                                                        </p>

                                                        <p><b>IP Address:</b> {router.ip_address}</p>

                                                        <p><b>Config IP:</b> {router.config_ip}</p>

                                                        <p><b>VPN IP:</b> {router.vpn_ip}</p>

                                                        <p><b>VPN Name:</b> {router.vpn_name}</p>

                                                        <p><b>serial_no:</b> {router.serial_no}</p>
                                                         <p><b>sim_card_number:</b> {router.sim_card_number}</p>

                                                        <p><b>IOT User:</b> {router.iot_username}</p>
                                                          <p><b>IOT Password:</b> {router.iot_password}</p>
                                                            <p><b>Parameter User:</b> {router.parameter_username}</p>
                                                                <p><b>Parameter Password:</b> {router.parameter_password}</p>
                                                                <p>
  <b>VPN File:</b>{" "}
  {router.vpn_file ? (
    <a
      href={`${router.vpn_file}`}
      target="_blank"
      rel="noopener noreferrer"
      download
    >
      Download VPN File
    </a>
  ) : (
    "-"
  )}
</p>

<p>
  <b>Configuration File:</b>{" "}
  {router.configuration_file ? (
    <a
      href={`${router.configuration_file}`}
      target="_blank"
      rel="noopener noreferrer"
      download
    >
      Download Config File
    </a>
  ) : (
    "-"
  )}
</p>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        );
                                    })}
                                </Row>

                            )}

                        </CardBody>
                    </Card>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default RouterConfig;